import { Link } from 'react-router-dom';
import type { SgSemaphoreLevel } from './types';

const LEVEL_STYLES: Record<SgSemaphoreLevel, { dot: string; border: string }> = {
  ok: { dot: 'bg-emerald-500', border: 'border-emerald-200' },
  warning: { dot: 'bg-amber-500', border: 'border-amber-200' },
  critical: { dot: 'bg-red-500', border: 'border-red-200' },
};

export interface SgKpiCardProps {
  title: string;
  to: string;
  primaryLabel: string;
  primaryValue: number;
  secondaryLabel?: string;
  secondaryValue?: number;
  percentLabel?: string;
  percentValue?: number;
  level: SgSemaphoreLevel;
}

export function SgKpiCard({
  title,
  to,
  primaryLabel,
  primaryValue,
  secondaryLabel,
  secondaryValue,
  percentLabel,
  percentValue,
  level,
}: SgKpiCardProps) {
  const styles = LEVEL_STYLES[level];

  return (
    <Link
      to={to}
      className={`block rounded-lg border bg-card p-4 shadow-sm transition hover:shadow-md ${styles.border}`}
      data-testid={`sg-kpi-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <div className='flex items-start justify-between gap-2'>
        <h3 className='text-sm font-medium text-foreground'>{title}</h3>
        <span
          className={`mt-1 h-2.5 w-2.5 shrink-0 rounded-full ${styles.dot}`}
          aria-hidden
        />
      </div>
      <div className='mt-3 space-y-1'>
        <p className='text-2xl font-semibold text-foreground'>{primaryValue}</p>
        <p className='text-xs text-muted-foreground'>{primaryLabel}</p>
        {secondaryLabel !== undefined && secondaryValue !== undefined && (
          <p className='text-xs text-muted-foreground'>
            {secondaryLabel}: <span className='font-medium text-foreground'>{secondaryValue}</span>
          </p>
        )}
        {percentLabel !== undefined && percentValue !== undefined && (
          <p className='text-xs text-muted-foreground'>
            {percentLabel}: <span className='font-medium text-foreground'>{percentValue}%</span>
          </p>
        )}
      </div>
    </Link>
  );
}
